import React from 'react';
import { render } from 'react-dom';
import PaymentFormPage from './pages/PaymentFormPage';

const payment = () => {
  const root = document.getElementById('react-root');

  render(
    <PaymentFormPage />,
    root,
  );
};

payment();
